import { Box } from "@mui/material";
import StickyNav from "./StickyNav";
import { theme } from "../styles/theme";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { Loading } from "./Loading";
import { ErrorComponent } from "./ErrorComponent";
import { loginRequest } from "../authConfig";
import { InteractionType } from "@azure/msal-browser";

type Props = {
  children?: React.ReactNode;
};

export const PageLayout: React.FC<Props> = ({ children }) => {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={loginRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <Box
        sx={{ height: "100%", bgcolor: theme.palette.background.default }}
      >
        {children}
        <StickyNav />
      </Box>
    </MsalAuthenticationTemplate>
  );
};
